import { render, staticRenderFns } from "./InteractiveListTest.vue?vue&type=template&id=b1189bf8"
import script from "./InteractiveListTest.vue?vue&type=script&lang=js"
export * from "./InteractiveListTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports